import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { ExternalShareExchangesState, SingleExternalShareExchange } from 'interfaces/external-share-exchange.interface';

import { createExternalShareExchange, getExternalShareExchange } from './action';

export function createExternalShareExchangeReducer(builder: ActionReducerMapBuilder<ExternalShareExchangesState>) {
  builder.addCase(createExternalShareExchange.pending, (state) => {
    state.exchange.isLoading = true;
  });

  builder.addCase(createExternalShareExchange.fulfilled, (state) => {
    state.exchange.isLoading = false;
  });

  builder.addCase(createExternalShareExchange.rejected, (state) => {
    state.exchange.isLoading = false;
  });
}

export function getExternalShareExchangeReducer(builder: ActionReducerMapBuilder<ExternalShareExchangesState>) {
  builder.addCase(getExternalShareExchange.pending, (state) => {
    state.exchange.isLoading = true;
  });

  builder.addCase(
    getExternalShareExchange.fulfilled,
    (state, action: PayloadAction<{ data: SingleExternalShareExchange }>) => {
      state.exchange.isLoading = false;
      state.exchange.data = action.payload.data;
    },
  );

  builder.addCase(getExternalShareExchange.rejected, (state) => {
    state.exchange.isLoading = false;
    state.exchange.data = {} as SingleExternalShareExchange;
  });
}
